import type { ApiResponseState } from "@codestreet/api";
import { reactive } from "vue";

import type { HandleFormErrors } from "./types";

export function useHandleFormErrors() {
  const state = reactive<HandleFormErrors>({
    main: "",
    fields: {},
  });

  const parse = (
    response: ApiResponseState<any>,
    noMain: boolean = false,
  ): HandleFormErrors | boolean => {
    if (!response.error) return false;
    if (!noMain) state.main = response.error.message || "";
    const fields: HandleFormErrors["fields"] = {};
    const details = response.error.errorsDetails;
    if (details) {
      if (Array.isArray(details)) {
        details.forEach((item) => (fields[item.key] = item.error));
      } else if (typeof details === "object") {
        Object.keys(details).forEach((item) => (fields[item] = details[item]));
      }
    }
    state.fields = fields;
    return state;
  };

  const clear = () => {
    state.main = "";
    state.fields = {};
  };

  return {
    state,
    parse,
    clear,
  };
}
